import { Tooltip, Typography } from '@mui/material';
import React from 'react';
// import KpiWorkunitGridData from 'types/entities/DashboardKpiMetric';

type KpiWorkunitGridData = {
  order_id?: number;
};

const OrderIdCell = React.memo((row: KpiWorkunitGridData) => (
  <>
    {row?.order_id && (
      <Tooltip title={row?.order_id}>
        <Typography variant="body2" noWrap>
          {row?.order_id}
        </Typography>
      </Tooltip>
    )}
  </>
));

export default OrderIdCell;
